import { configureStore } from '@reduxjs/toolkit'
import inksoftCommissionReducer from './InksoftCommissions/inksoftCommissionSlice'

export const store = configureStore({
  reducer: {
    inksoftCommission: inksoftCommissionReducer
  },
})